import React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";

import { GameData } from "types";
import PublicCashTable from "../Tables/PublicCash";
import PrivateCashTable from "../Tables/PrivateCash";
import PublicTournamentTable from "../Tables/PublicTournament";
import PrivateTournamentTable from "../Tables/PrivateTournament";
import PrivateGameSearch from "../../PrivateGameSearch.jsx";

const StyledTab = styled(Tab)(() => ({
  "&.Mui-selected": {
    color: "teal",
    backgroundColor: grey[100],
    border: "1px solid teal",
  },
  "&:hover": {
    backgroundColor: grey[200],
  },
}));


interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      sx={{ width: "100%" }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

interface CenteredTabsProps {
  setModalDets: (dets: any) => void;
  setGameData: (data: GameData) => void;
}

export default function CenteredTabs({ setModalDets, setGameData }: CenteredTabsProps) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ flexGrow: 1, marginBottom: "50px" }}>
      <Paper sx={{ borderRadius: "25px" }} elevation={5}>
        <Tabs
          sx={{
            backgroundColor: grey[200],
            borderRadius: "25px",
          }}
          indicatorColor="primary"
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          centered
        >
          <StyledTab label="Public Cash" />
          <StyledTab label="Public Tournament" />
          <StyledTab label="Private Cash" />
          <StyledTab label="Private Tournament" />
        </Tabs>
      </Paper>
      <TabPanel value={value} index={0}>
        <Box>
          <Typography 
            variant="h4" 
            component="h1" 
            id="PublicTitle" 
            sx={{ 
              fontFamily: '"Courgette", cursive',
              color: 'rgb(0, 132, 255)',
              textAlign: 'center',
              textShadow: '2px 1px #000000',
              WebkitTextStroke: '1px black',
            }}
          >
            Public Cash Games
          </Typography>
          <PublicCashTable
            setModalDets={setModalDets}
            setGameData={setGameData}
          />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Box>
          <Typography 
            variant="h4" 
            component="h1" 
            id="PublicTitle" 
            sx={{ 
              fontFamily: '"Courgette", cursive',
              color: 'rgb(0, 132, 255)',
              textAlign: 'center',
              textShadow: '2px 1px #000000',
              WebkitTextStroke: '1px black',
            }}
          >
            Public Tournaments
          </Typography>
          <PublicTournamentTable
            setModalDets={setModalDets}
            setGameData={setGameData}
          />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Box>
          <Typography 
            variant="h4" 
            component="h1" 
            id="PublicTitle" 
            sx={{ 
              fontFamily: '"Courgette", cursive',
              color: 'rgb(0, 132, 255)',
              textAlign: 'center',
              textShadow: '2px 1px #000000',
              WebkitTextStroke: '1px black',
            }}
          >
            Private Cash Games
          </Typography>
          <PrivateCashTable
            setModalDets={setModalDets}
            setGameData={setGameData}
          />
          <PrivateGameSearch />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Box>
          <Typography 
            variant="h4" 
            component="h1" 
            id="PublicTitle" 
            sx={{ 
              fontFamily: '"Courgette", cursive',
              color: 'rgb(0, 132, 255)',
              textAlign: 'center',
              textShadow: '2px 1px #000000',
              WebkitTextStroke: '1px black',
            }}
          >
            Private Tournaments
          </Typography>
          <PrivateTournamentTable
            setModalDets={setModalDets}
            setGameData={setGameData}
          />
          <PrivateGameSearch />
        </Box>
      </TabPanel>
    </Box>
  );
}
